module.exports = Marionette.ItemView.extend( {
	template: '#tmpl-kitbuilder-panel-revisions-no-revisions',

	id: 'kitbuilder-panel-revisions-no-revisions',

	className: 'kitbuilder-panel-nerd-box'
} );
